import { CircularProgress, Typography, WithStyles } from "@material-ui/core";
import { styles } from "./InternalUserRegistrationView.styles";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as InternalUserAction from "../../../stores/internal/InternalUserAction";
import * as UserDetailsAction from "../../../stores/user/UserDetailsAction";
import { useHistory } from "react-router-dom";
import { useAuthContext } from "../../../auth/AuthProvider";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { withStyles } from "@material-ui/core/styles";
import { isUsedOpenAM } from "../../../utilities/userUtils";
import { LogoutReason } from "../../../constants/LOGOUT";
import { LOGIN_REDIRECT } from "../../../auth/authClient/src/constants";
import { redirectToPrevious } from "../../../utilities/generalUtils";

interface InternalUserRegistrationProps extends WithStyles<typeof styles> {
}

const InternalUserRegistrationViewPure: React.FunctionComponent<InternalUserRegistrationProps> = ({classes}) => {
    const authContext = useAuthContext();
    const history = useHistory();
    const dispatch = useDispatch();

    const internalUserConfirmed = useSelector(state => state.internalUser.confirmed);
    const decodedToken = authContext.token;
    const isLoggingIn = window.location.search.includes("code=");
    const userId = authContext?.user?.id;

    const redirectLoginView = String(localStorage.getItem(LOGIN_REDIRECT));

    useEffect(() => {
        if (isUsedOpenAM() && !internalUserConfirmed) {
            if (decodedToken) {
                dispatch(InternalUserAction.registerInternalUser(decodedToken)).then(() => {
                    dispatch(UserDetailsAction.initUser(userId));
                });
            }
        }
    }, [dispatch, internalUserConfirmed, decodedToken, userId]);

    useEffect(() => {
        if (authContext.error !== "") authContext.logoutWithRedirect(LogoutReason.InsufficientRoles);
        if (isUsedOpenAM() && internalUserConfirmed) {
            if (redirectToPrevious(redirectLoginView)) {
                history.replace(redirectLoginView);
                localStorage.removeItem(LOGIN_REDIRECT);
            } else {
                history.push("/");
            }
        }
        // eslint-disable-next-line
    }, [dispatch, internalUserConfirmed, authContext.error]);

    return (
        <CenteredContainer>
            {isLoggingIn && (
                <div className={classes.loggingIn}>
                    {authContext.error === "" ? (
                        <>
                            <CircularProgress />
                            <Typography variant="h4">Logging in. Please wait...</Typography>
                        </>
                    ) : (
                        <>
                            <CircularProgress />
                            <Typography variant="h4">Login failed. You are being logged out.</Typography>
                        </>
                    )}
                </div>
            )}
        </CenteredContainer>
    );
};

export const InternalUserRegistrationView = withStyles(styles)(InternalUserRegistrationViewPure);
